import {
  boxcryptorEnterpriseTheme,
  boxcryptorGreenWebsiteTheme,
  PreferredColorSchemeProvider,
  Theme as ThemeInstance,
  ThemeProvider,
} from '@boxcryptor-web/theme';
import '@boxcryptor-web/ui/index.css';
import React from 'react';
import { Banner } from './components/Banner';
import { ExternalLinkContextProvider } from './components/links/ExternalLinkContextProvider';
import { GatsbyLinkContextProvider } from './components/links/GatsbyLinkContextProvider';
import { LinkIdContextProvider } from './components/links/LinkIdContext';
import './index.css';
import { CurrencyProvider, PageContextContextProvider, PaginationContextContextProvider, Theme } from './node/context';
import { GatsbyPageContext } from './node/gatsby-page';

export type PageWrapperProps = {
  page: React.ReactElement;
  data: Record<string, unknown>;
  pageContext: GatsbyPageContext;
};

export const themes: Record<Theme, ThemeInstance> = {
  blue: boxcryptorEnterpriseTheme,
  green: boxcryptorGreenWebsiteTheme,
};

export const PageWrapper: React.FC<PageWrapperProps> = (props) => {
  const { page, pageContext } = props;

  if (!pageContext.pageContext) {
    return <div>{page}</div>;
  }
  const theme = themes[pageContext.pageContext.theme];

  return (
    <PageContextContextProvider value={pageContext.pageContext}>
      <CurrencyProvider value={pageContext.currency}>
        <LinkIdContextProvider value={{ idPrefix: pageContext.pageContext.linkedUrls.defaultUrl }}>
          <ExternalLinkContextProvider baseUrl={pageContext.linkContext.baseUrl}>
            <GatsbyLinkContextProvider {...pageContext.linkContext}>
              <PaginationContextContextProvider value={pageContext.paginationContext}>
                <PreferredColorSchemeProvider value="light">
                  <ThemeProvider theme={theme}>
                    <Banner></Banner>
                    {page}
                  </ThemeProvider>
                </PreferredColorSchemeProvider>
              </PaginationContextContextProvider>
            </GatsbyLinkContextProvider>
          </ExternalLinkContextProvider>
        </LinkIdContextProvider>
      </CurrencyProvider>
    </PageContextContextProvider>
  );
};
